import { Field, FlowJson, Footer, FormInputInterface, getGenericDataTypeList, Payload, TextInput } from './whatsappFlowTypes';

export const initialCreateWAFlowPayload = {
    meta_integration_whatsapp_id: "",
    whatsapp_flow_name: "",
    whatsapp_flow_description: ""
}
export function validateWhatsappFlowJson(
    jsonString: string, genericDataTypeList: getGenericDataTypeList[] | null,
): { valid: boolean; error?: string; json?: FlowJson } {
    try {
        const json = JSON.parse(jsonString);

        if (!json.version) {
            return { valid: false, error: 'Missing required field: "version".' };
        }

        if (!Array.isArray(json.screens) || json.screens.length === 0) {
            return { valid: false, error: 'No screens defined in "screens".' };
        }

        const firstScreen = json.screens[0];
        if (!firstScreen.id || !firstScreen.layout) {
            return {
                valid: false,
                error: 'First screen must have "id" and "layout".',
            };
        } 
        const payload = convertFlowToPayload(json, genericDataTypeList); 
        if(payload?.output_variable?.length == 0){
            return {
                valid: false, 
                error: 'No output variables defined in last screen.',
            }
        }

        return { valid: true, json };
    } catch (e) {
        return { valid: false, error: 'Invalid JSON format.' };
    }
}

export function convertFlowToPayload(flowJson: FlowJson, genericDataTypeList: getGenericDataTypeList[] | null): Payload {
    const payload: Payload = {
        flow: flowJson,
        input_var: [],
        output_variable: []
    };

    try {
        const screens = flowJson?.screens || [];
        if (screens.length === 0) return payload;

        const dataFields: Record<string, Field> = screens[0].data || {};
        const form = screens[screens?.length - 1]?.layout?.children?.find(
            (child) => (child as FormInputInterface)?.type?.toLowerCase() === "form"
        ) as FormInputInterface | undefined;

        const footerPayload = (form?.children?.find(
            (child) => (child as FormInputInterface)?.type?.toLowerCase() === "footer"
        ) as Footer)?.['on-click-action']?.payload || {};

        console.log(footerPayload, "footerPayload")
        console.log(dataFields, "dataFields")

        Object.entries(dataFields).forEach(([fieldName, fieldProps]) => {
            const type = fieldProps.type;
            const example = fieldProps.__example__;

            if (example !== undefined) {
                const valueArray = Array.isArray(example)
                    ? example.map((item) => (
                        {
                            whatsapp_flow_variable_data_id: null,
                            identifier: item?.id,
                            display_value: item?.title
                        }))
                    : [
                        {
                            whatsapp_flow_variable_data_id: null,
                            identifier: null,
                            display_value: example
                        }
                    ];

                payload.input_var.push({
                    whatsapp_flow_variable_id: null,
                    variable_key: fieldName,
                    variable_label: fieldName,
                    data_type_id: genericDataTypeList?.find((list) => list.data_type_name == type)?.data_type_id || "",            
                    input_variable_flag: true,
                    whatsapp_flow_variable_data: valueArray
                });
            }

            // payload.output_variable.push({
            //     field_name: fieldName
            // });
        });

        Object.entries(footerPayload).forEach(([fieldName, fieldProps]) => {
            if (fieldProps !== undefined) {
                payload.output_variable.push({
                    whatsapp_flow_variable_id: null,
                    variable_key: fieldName,
                    variable_label: fieldName,
                    data_type_id: genericDataTypeList?.find((list) => list.data_type_name == "string")?.data_type_id || "",            
                    input_variable_flag: false,
                    whatsapp_flow_variable_data: [
                        {
                            whatsapp_flow_variable_data_id: null,
                            identifier: null,
                            display_value: null
                        }
                    ]
                });
            }
        });

    } catch (err) {
        console.error('Error parsing flow JSON:', err);
    }

    return payload;
}
